import { icon_scanbody } from 'components/base/images';
import CustomText from 'components/common/text/CustomText';
import { IConvertFile } from 'lib/types/clinic/fileTypes';
import _ from 'lodash';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import cx from 'classnames';

interface ProjectFileIconProps {
  file: IConvertFile;
}
function ProjectFileIcon({ file }: ProjectFileIconProps) {
  const { fileType, fileTypeText, scanOption, fileExtension } = file;

  return (
    <StyledProjectFileIcon data-component-name="ProjectFileIcon">
      <div className="projectFileIcon__extension_box">
        <CustomText
          fontSize={14}
          fontWeight={600}
          fontColor={'#444'}
          className="projectFileIcon__extension"
        >
          {fileExtension}
        </CustomText>
      </div>
      {scanOption === 'PREOP' && (
        <div className="projectFileIcon__box text">
          <CustomText
            fontSize={10}
            fontWeight={400}
            fontColor={'#00A6E2'}
            className="projectFileIcon__icon"
          >
            {`Pre\nOp`}
          </CustomText>
        </div>
      )}
      {scanOption === 'SCANBODY' && (
        <div
          className={cx('projectFileIcon__box icon', {
            isUpper: fileType === 'UPPER',
          })}
        >
          <img className="projectFileIcon__icon" src={icon_scanbody} />
        </div>
      )}
      {!!scanOption && /OCCLU\d/.test(scanOption) && (
        <div className="projectFileIcon__box text">
          <CustomText
            fontSize={14}
            fontWeight={600}
            fontColor={'#00A6E2'}
            className="projectFileIcon__icon"
          >
            {scanOption.replace(/OCCLU/, '')}
          </CustomText>
        </div>
      )}
    </StyledProjectFileIcon>
  );
}

const StyledProjectFileIcon = styled.div<{}>`
  display: flex;
  align-items: center;
  width: 66px;
  height: 24px;
  column-gap: 2px;
  .projectFileIcon__extension_box {
    height: 24px;
    padding: 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    .projectFileIcon__extension {
      max-width: 66px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .projectFileIcon__box {
    width: 24px;
    height: 24px;
    background-color: rgba(204, 237, 249, 0.7);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: pre-wrap;
    &.isUpper {
      rotate: 180deg;
    }
    .projectFileIcon__icon {
      text-align: center;
    }
  }
`;

export default React.memo(ProjectFileIcon);
